<template>
  <div class="banner-box">
    <el-carousel height="30vw" :interval="5000" :trigger="'click'" v-if="banner">
      <el-carousel-item v-for="v in banner" :key="v.id">
        <img class="bg" :src="isHead(v.imgpath1)" alt="">
        <el-image 
          style="width: 100%; height: 100%"
          :src="isHead(v.imgpath1)" 
          fit="contain"
          @click="openInfo(v)">
         
          
        </el-image>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>

import { reactive, toRefs, watch  } from "vue"
import { api } from "@/api"
import { useStore} from "vuex"
import { isHead } from "@/tools"
import { openInfo } from "@/tools/jump.js"
export default {
  name: "banner",
  components: {},
  setup() {
    let store = useStore()
    let initData = reactive({
      banner_loading: false,
      banner: "",
      bannerBg: ""

    })
    watch(
      () => store.state.bannerData,
      (newVal) => {
        initData.banner = newVal;
        if (!newVal) {
          getBanner()
        }
      },
      { immediate: true, deep: true }
    )
    function getBanner() {
      initData.banner_loading = true
      api('get', 'listortop2',{classid: "1001", istop: 1})
        .then(res => {
          initData.banner_loading = false
          if(res.code === 1200) {
            store.commit("setBanner", res.data)
            if(res.data && res.data[0]) initData.bannerBg = isHead(res.data[0].imgpath1)
            
          }
        })
        .catch(err => {
          initData.banner_loading = false
        })
    }

    return {
      ...toRefs(initData),
      isHead,
      openInfo
    }
  }
}
</script>

<style lang="less" scoped>
.banner-box {
  background-image: url('~@/assets/images/load.jpg');
  background-size: contain;
  background-repeat: no-repeat;
  background-position-x: center;
  background-color: #f7f8fa;
}
:deep(.el-carousel__item .bg) {
  content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 30vw;
    // background-image: var(--bg);
    filter: blur(107px);
    z-index: -1;
    // background-size: cover;
    object-fit: cover;
} 
:deep(.el-carousel__button) {
  width: 10px;
  height: 10px;
  background-color: #fff;
  opacity: 1;
  border-radius: 10px;
}
:deep(.el-carousel__indicator.is-active button) {
  width: 30px;
  background-color: #10BB58;
}
</style>